import MuiAppBar from "@mui/material/AppBar";
import MuiToolbar from "@mui/material/Toolbar";
import { RouteFeature, useLock, useRoutes, useManageNavigation } from "@/hooks";
import { TabNavigation } from "@/components/Navigation";
import TripSelectorMenu from "./TripSelectorMenu";
import NotificationMenu from "./NotificationMenu";
import ExternalLinksMenu from "./ExternalLinksMenu";
import ProfileMenu from "./ProfileMenu";
import MobileProfileMenu from "./MobileProfileMenu";
import RewardMenu from "./RewardMenu";
import { useResponsive } from "@/hooks";
import Logo from "./Logo";
import ChatIconButton from "./ChatIconButton";
import RewardIconButton from "./RewardIconButton";
import styles from "./MobileHeader.module.scss";

const Header: React.FC<{ className?: string }> = ({ children, className }) => {
  const { routes, getMatchedRoute } = useRoutes();
  // const { isAllowedToNavigate } = useManageNavigation();
  const { isMobile } = useResponsive();
  const { route } = getMatchedRoute();
  const hasMobileTripSelector = route?.features?.includes(
    RouteFeature.HasMobileTripSelector
  );

  return (
    <MuiAppBar color="inherit" elevation={0} className={className}>
      <MuiToolbar className={styles.toolbar}>
        {Boolean(children) ? (
          children
        ) : (
          <>
            <MobileProfileMenu />
            <Logo />

            <RewardIconButton className={styles.rewardMobileButton} />
            <ChatIconButton stickToEnd />
            <NotificationMenu />
          </>
        )}
      </MuiToolbar>
    </MuiAppBar>
  );
};

export default Header;
